<template>
  <div>
    <a-button @click="handleAdd" class="dg-base-btn" v-if="isShowBtn">
      添加
    </a-button>
    <a-table
      bordered
      :data-source="defaultValue"
      :columns="instance.columns"
      :scroll="{ x: 'calc(700px + 50%)', y: yScroll }"
      :pagination="false"
      v-bind="instance"
    >
      <template
        v-for="item in slotOpt"
        :slot="item.slot"
        slot-scope="text, scope, index"
      >
        <span :key="item.slot">
          <component
            v-on="$listeners"
            :is="item.component"
            :instance="item"
            :scope="{ text, scope, index, customPaginationOpt }"
          >
          </component>
        </span>
      </template>
    <!-- editArr不存在时,即为查看表格而已 -->
      <template
        :slot="item"
        slot-scope="text, record"
        v-for="(item, index) in instance.editArr"
      >
        <editable-cell
          :text="text"
          :key="'item' + index"
          :precision="record.precision"
          @change="onCellChange(record.key, item, $event, record)"
          :ref="item + count + 'Ref'"
          v-bind="$attrs"
        />
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="delClick(text, record)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import EditableCell from './EditTableCell'
import TextAction from '@/views/Back/components/formTable/components/textAction.vue'
import { baseTableSlot } from '@/views/Back/components/formTable/components/configs/config'
export default {
  inheritAttrs: false,
  props: {
    customPaginationOpt: Object, 
    instance: Object,
    isShowBtn: {
      type: Boolean,
      default: true
    },
    yScroll: {
      type: Number,
      default: 500
    },
    customSlotOpt: Array, // table的插槽配置文件
  },
  components: {
    EditableCell,
    TextAction
  },
  data() {
    return {
      baseTableSlot, // 默认的插槽配置
      count: 1,
      defaultValue: [],
      key: null,
      slotOpt: [], // 合并自定义与默认表格的插槽配置
    }
  },
  watch: {
    // defaultValue(val) {
    //
    //   if (val) {
    //     this.count = val.length + 1
    //     this.key = val.length + 1
    //   }
    // },
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.setSlotOpt() // 初始化插槽配置
  },
  methods: {
     // 初始化插槽配置
    setSlotOpt() {
      const resultOpt = [].concat(this.baseTableSlot) // 最终结果配置
      if (this.customSlotOpt) {
        this.customSlotOpt.forEach(item => {
          const includeIndex = resultOpt.findIndex(t => t.slot === item.slot) // 存在
          if (includeIndex !== -1) {
            // 根据下标替换
            resultOpt.splice(includeIndex, 1, item)
          } else {
            resultOpt.push(item)
          }
        })
      }
      this.slotOpt = resultOpt
    },
    onCellChange(key, dataIndex, value, record) {
      if(value === null){
        value = ''
      }
      const defaultValue = [...this.defaultValue]
      const target = defaultValue.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.defaultValue = defaultValue
        // 修改数据源的表格数据
        this.$emit('change', { key, dataIndex, value, record })
      }
    },

    delClick(text, record) {
      this.defaultValue.forEach((item, key) => {
        if (item.key === record.key) {
          this.defaultValue.splice(key, 1)
        }
      })

      this.defaultValue.forEach((item, key) => {
        item.serialNo = key + 1
      })
      // this.$emit('rowDelClick', record)
    },
    handleAdd() {
      let { count, defaultValue, key } = this
      key = `${new Date()}` + count

      if (defaultValue === undefined) {
        defaultValue = []
      }
      if (defaultValue.length > 0) {
        count = defaultValue.length + 1
      }
      const newData = {
        serialNo: count,
        applicationNo: '',
        name: '',
        applicant: '',
        inventor: '',
        publicationNo: '',
        legalStatus: '',
        key: key
      }
      // 修改数据源的表格数据
      this.defaultValue = [...defaultValue, newData]

      // this.$emit('valueChange', [...defaultValue, newData])
      this.$emit('change', [...defaultValue, newData])
      this.count = count + 1
      setTimeout(() => {
        this.instance.editArr.forEach(item => {
          let str = item + this.count + 'Ref'
          this.$refs[str][0].editable = true
        })
      })
    }
  }
}
</script>
